import * as yup from 'yup'

export const schemaStepPerson = yup.object().shape({
  name: yup.string().required(),
  email: yup
    .string()
    .email()
    .emailAvailable()
    .required(),
  cpf: yup
    .string()
    .cpf()
    .cpfAvailable({ kindRef: yup.ref('kind') })
    .required(),
  phone: yup.string().required(),
})

export default schemaStepPerson
